import { api_path } from "../environment";

export const apiPaths = {
  baseUrl: api_path,
};

export const setHeaders = (context) => {
  // Si un contexte est fourni l'ajouter aux en-têtes

  let headers = {
    "content-type": "application/json",
    withCredentials: true,
  };

  if (context) {
    headers["x-context"] = context;
  }
  return headers;
};
